import { Box, Tooltip } from '@mui/material';
import type { GridColDef, GridRenderCellParams, GridRenderEditCellParams } from '@mui/x-data-grid-premium';
import NotesHistoryButton from '../NotesHistoryButton';
import NotesEditCell from './NotesEditCell';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NIL = '00000000-0000-0000-0000-000000000000';

export function notesColumn({ entity, editable }: { entity: string; editable: boolean }): GridColDef {
  return {
    field: 'notes', headerName: 'Notes', width: 200, minWidth: 100, sortable: false, filterable: false, editable,
    description: editable ? 'Double-click to edit. Enter saves, Shift+Enter adds a line, Esc cancels.' : undefined,
    renderEditCell: (params: GridRenderEditCellParams) => <NotesEditCell {...params} />,
    // Report rows also include the totals and "(none)": no entity behind them.
    renderCell: (params: GridRenderCellParams) => (!UUID.test(String(params.row.id)) || params.row.id === NIL ? null : (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, width: '100%', height: '100%', minWidth: 0 }}>
        {params.value ? (
          <Tooltip title={<Box sx={{ whiteSpace: 'pre-line' }}>{String(params.value)}</Box>} placement="bottom-start">
            <Box component="span" sx={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{String(params.value)}</Box>
          </Tooltip>
        ) : <Box sx={{ flex: 1 }} />}
        <NotesHistoryButton entity={entity} id={String(params.row.id)} className="notes-history-btn" />
      </Box>
    )),
  };
}

/** For a grid's row double-click that opens the entity: a double-click on the note edits it instead. */
export const inNotesCell = (target: EventTarget | null) => !!(target as HTMLElement | null)?.closest?.('[data-field="notes"]');

export const notesGridSx = {
  '& .notes-history-btn': { opacity: 0.35 },
  '& .MuiDataGrid-row:hover .notes-history-btn': { opacity: 1 },
};
